import api from "@/services/api.ts";
import {MenteeUserInfo} from "@/types/Mentee.ts";

const URL = '/send-email';

export const sendWelcomeEmail = async (role: string, email: string, name: string, deadline: string) => {
    try {
        const response = await api.post(`${URL}/welcome`, {
            role,
            email,
            name,
            deadline
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to send email');
    }
};

export const sendMatchesAvailableEmail = async (mentees: MenteeUserInfo[], deadline: string) => {
    try {
        const trimmedMentees = mentees.map(m => ({ email: m.user.email, fullName: m.user.fullName }));
        const response = await api.post(`${URL}/matches-available`, {
            mentees: trimmedMentees,
            deadline
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to send email');
    }
};


export const sendMentorshipGroupAvailableEmail = async () => {
    try {
        const response = await api.post(`${URL}/mentorship-group-available`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to send email');
    }
};

export const sendPreferenceSubmissionReminderEmail = async (deadline: string) => {
    try {
        const response = await api.post(`${URL}/submit-preference`, {deadline}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to send email');
    }
};

export const sendMentorSelectionReminderEmail = async (deadline: string) => {
    try {
        const response = await api.post(`${URL}/select-mentor`, {deadline}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to send email');
    }
};
